import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Tooltip } from '@mui/material';

const EnrollButton = ({ onClick, enrollmentStatus, intl }) => {
  const getToolTipText = () => {
    if (enrollmentStatus.alreadyEnrolled) {
      return intl.formatMessage({ id: 'trials.alreadyEnrolled' });
    }
    if (enrollmentStatus.notInsideRegistration) {
      return intl.formatMessage({ id: 'trials.registraionClosed' });
    }

    return '';
  };

  const disableButton = enrollmentStatus.alreadyEnrolled
    || enrollmentStatus.notInsideRegistration;

  return (
    <Tooltip title={getToolTipText()}>
      <Button
        variant="contained"
        className="TrialEnroll-button"
        color="primary"
        onClick={onClick}
        disabled={disableButton}
      >
        <div className="pl2 pr2 flex items-center justify">
          <span className="white">
            <FormattedMessage id="trials.enroll" />
          </span>

        </div>
      </Button>
    </Tooltip>
  );
};

EnrollButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  enrollmentStatus: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(EnrollButton);
